import { LuUsers as Users } from "react-icons/lu";
import { SectionHeader } from "../section-header";
import { StatCard } from "../stat-card";
import React from "react";
import { StatsByCategoryMap } from "../../types";
import { calcPercentage } from "../../utils/stats.util";

type Props = {
  stats: StatsByCategoryMap["USERS"];
  expiry: number;
};

export const UsersStatsSection: React.FC<Props> = ({ stats, expiry }) => {
  return (
    <div className="mb-8">
      <SectionHeader icon={Users} title="Users Statistics" updateInfo={expiry} />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
        <StatCard icon={Users} title="Total Users" value={stats.TOTAL_USERS.count} />
        <StatCard
          icon={Users}
          title="New Users (Last Month)"
          value={stats.LAST_MONTH_USERS.count}
          change={`${calcPercentage(stats.TOTAL_USERS.count, stats.LAST_MONTH_USERS.count)}% of Total`}
        />
        <StatCard
          icon={Users}
          title="Coaches"
          value={stats.TOTAL_COACHES.count}
          change={`${calcPercentage(stats.TOTAL_USERS.count, stats.TOTAL_COACHES.count)}% of Total`}
          changeColor="text-gray-600"
        />
        <StatCard
          icon={Users}
          title="Learners"
          value={stats.TOTAL_LEARNERS.count}
          change={`${calcPercentage(stats.TOTAL_USERS.count, stats.TOTAL_LEARNERS.count)}% of Total`}
          changeColor="text-gray-600"
        />
        <StatCard
          icon={Users}
          title="DUAL-Role Users"
          value={stats.TOTAL_DUAL_ROLE.count}
          change={`${calcPercentage(stats.TOTAL_USERS.count, stats.TOTAL_DUAL_ROLE.count)}% of Total`}
          changeColor="text-gray-600"
        />
      </div>
    </div>
  );
};
